import { render, staticRenderFns } from "./massUserResetPassword.vue?vue&type=template&id=799d93d2"
import script from "./massUserResetPassword.vue?vue&type=script&lang=js"
export * from "./massUserResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports